<template>
  <div class="change-status">
    <div class="change-status__title">URL Status Changing</div>
    <div class="change-status__header">

      <div class="change-status__title-wrapper">
        <div class="change-status__info-item" :style="elementStyle">
          <div class="change-status__header-title">Target Date</div>
          <base-date-picker-button
            class="change-status__date"
            v-model="date"
          ></base-date-picker-button>
        </div>
        <div class="change-status__info-item" :style="elementStyle">
          <div class="change-status__header-title">URL Status</div>
          {{urlData.status}}
        </div>
        <div class="change-status__info-item" :style="elementStyle">
          <div class="change-status__header-title">Brief Status</div>
          {{urlData.briefStatus}}
        </div>
        <div class="change-status__info-item" :style="elementStyle">
          <div class="change-status__header-title">Section</div>
          {{urlData.section}}
        </div>
        <div class="change-status__info-item" :style="elementStyle">
          <div class="change-status__header-title">#KW</div>
          {{urlData.keywords}}
        </div>
        <div class="change-status__info-item" :style="elementStyle">
          <div class="change-status__header-title">Total MSV</div>
          {{urlData.msv | commaDividedNumber}}
        </div>
      </div>
    </div>
    <label class="change-status__input">
      <span class="change-status__label">URL</span>
      <div class="change-status__link-wrapper">
        <input type="text"
               class="form-control change-status__link-field"
               disabled
               readonly
               v-model="url.url">
      </div>
    </label>
    <label class="change-status__input">
      <span class="change-status__label">Notes:</span>
      <div class="form-control description__wrapper" :class="{'form-control_error': isDescriptionError}">
      <textarea
        class="description"
        rows="6"
        placeholder="Enter Notes"
        v-model="description"></textarea>
        <span class="error__message-description" v-if="isDescriptionError">Note should be present</span>
      </div>
    </label>
    <div class="change-status__controls">
      <button class="change-status__button change-status__button_cancel"
              @click.prevent="cancel()">Cancel
      </button>
      <button class="change-status__button change-status__button_submit"
              @click.prevent="apply()">
        Apply
      </button>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import Filters from '@/common/Filters'

/**
 * Popup is shown when we change URL status, example: from 'Planed' to 'Published'
 */
export default {
  name: 'UrlStatusPopup',
  props: ['url', 'statuses', 'isContentBrief'],
  /**
   * this logic for adjust UI to data shown in the header
   */
  mounted () {
    const width = Array.from(document.getElementsByClassName('change-status__info-item')).reduce((acc, item) => {
      acc += this.calculateElementWidth(item)
      return acc
    }, 0)
    const header = parseInt(window.getComputedStyle(document.getElementsByClassName('change-status__header')[0]).paddingLeft)
    const padding = parseInt((document.getElementsByClassName('change-status__title-wrapper')[0].offsetWidth - (header * 2) - width) / 6)
    this.elementStyle = {
      'padding-left': `${parseInt(padding / 2)}px`,
      'padding-right': `${parseInt(padding / 2)}px`
    }
  },
  data () {
    return {
      description: '',
      date: this.calculateDate(this.url['target_date'] || ''),
      elementStyle: {},
      isValidating: false,
      pickerProps: {
        placeholder: 'Enter Date',
        class: 'input-date',
        readonly: true
      }
    }
  },
  computed: {
    urlData () {
      const date = this.url['target_date'] || ''
      const status = this.statuses.find(item => item._id === this.url.currentUrlStatus).label || ''
      const briefStatus = this.url['brief_status'].name || ''
      const section = this.url['section'].name || ''
      const keywords = this.url['keywords'] || this.url['keywords'] === 0 ? this.url['keywords'] : ''
      const msv = (this.url['msv'] || this.url['msv'] === 0) ? this.url['msv'] : ''
      return {
        date, status, briefStatus, section, keywords, msv
      }
    },
    isDescriptionError () {
      return this.isContentBrief && this.isValidating && !this.description
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    },
    isFormInvalid () {
      return this.isDescriptionError
    },
    apply () {
      this.isValidating = true
      if (this.isFormInvalid()) {
        return
      }
      this.$emit('apply', { description: this.description, date: this.date })
    },
    /**
     * converts source date to use it in date picker
     * @param date - source date
     * @returns {string|Date} - prepared date
     */
    calculateDate (date) {
      if (!date) return ''
      date = date.replace(/ /g, 'T')
      if (!date.includes('T')) {
        date += 'T00:00:00'
      }
      return moment(date).toDate()
    },
    calculateElementWidth (el) {
      return el.offsetWidth
    }
  },
  filters: {
    ...Filters
  }
}
</script>

<style lang="scss">
  .change-status {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 40px;

    &__title-wrapper {
      display: flex;
      justify-content: space-evenly;
      height: 60px;
    }

    &__title {
      text-align: center;
      font-size: 34px;
      font-weight: 500;
      margin: 9px 0 35px;
      color: $rfx-dark-march;
    }

    &__header {
      background-color: rgba(1, 22, 39, 0.1);
      height: 120px;
      display: flex;
      flex-direction: column;
      margin: 0 -40px;
      padding-right: 40px;
      padding-left: 40px;
    }

    &__header-title {
      color: $rfx-dark-march;
      font-weight: bold;
      padding: 22px 0 5px;
      border: none;
      display: flex;
      align-items: flex-end;
      margin-bottom: 10px;
      margin-top: 10px;

    }

    &__info-item {
      color: $rfx-light-march;
      border: none;
      padding: 5px 0 22px;

    }

    &__input {
      display: flex;
      flex-direction: column;
      position: relative;
      margin-top: 30px;

      &_invalid[type='text'] {
        border: 1px solid $rfx-red;
        border-radius: 4px;
      }
    }

    &__label {
      display: block;
      font-weight: 600;
      margin-bottom: 5px;
      color: $rfx-dark-march;
    }

    &__controls {
      display: flex;
      justify-content: flex-end;
      margin-top: 30px;
    }

    &__button {
      width: 100px;
      height: 40px;
      border-radius: 4px;
      font-size: 10px;
      font-weight: 900;
      text-transform: uppercase;
      margin-left: 30px;
      border: none;
      outline: none;
      cursor: pointer;

      &_submit {
        background-color: $rfx-medium-march;
        color: #fff;

        &:disabled {
          pointer-events: none;
          background-color: #fff;
          color: $rfx-neutral-grey;
          cursor: default;
        }
      }

      &_disabled {
        pointer-events: none;
        background-color: #fff;
        color: $rfx-neutral-grey;
        cursor: default;
      }

      &_cancel {
        color: $rfx-dark-march;
        background-color: #fff;
      }
    }

    &__link {
      &-wrapper {
        position: relative;
      }

      &-field[type='text'] {
        width: 100%;
        box-sizing: border-box;
        padding-right: 60px;
        font-weight: 500;
        @include ellipsis;
      }
    }

    &__date {
      margin-top: -9px;
    }
  }

  .form-control {
    height: 50px;
    padding: 0 20px;
    border: 2px solid $rfx-light-steel;
    outline: none;
    border-radius: $rfx-default-border-radius;
    font-size: 14px;
    font-weight: 600;
    color: $rfx-dark-march;

    &::placeholder {
      color: $rfx-pearl;
      font-weight: normal;
      font-size: 14px;
    }

    &:disabled {
      background-color: $rfx-light-steel;
    }

    &_error {
      border-color: $rfx-red;
      color: $rfx-red;

      &::placeholder {
        color: $rfx-red;
        font-size: 13px;
      }

    }
  }

  .description {
    width: 100%;
    padding: 0;
    resize: none;
    outline: none;
    border: none;

    &::placeholder {
      color: $rfx-pearl;
      font-weight: normal;
      font-size: 14px;
    }

    &__wrapper {
      padding: 10px 20px;
      height: auto;
    }
  }

  .input-date {
    border: none;
    box-shadow: none;
    text-decoration: underline;
    background-color: transparent;
    padding: 0;
    color: $rfx-bright-blue;
    font-size: 13px;
    width: 85px;
    vertical-align: top;

    &::placeholder {
      color: $rfx-bright-blue;
      text-decoration: underline;
      font-size: 13px;
    }

    &_error {
      &::placeholder {
        color: $rfx-red;
        text-decoration: underline;
        font-size: 13px;
      }
    }
  }

  .error {
    &__message-description,
    &__message {
      color: $rfx-red;
      position: absolute;
      top: 75px;
      font-size: 10px;
      font-weight: normal;
    }

    &__message-description {
      top: 154px;
      left: 0;
    }
  }

</style>
